<script lang="ts">
  import { useForm, usePage } from '@inertiajs/svelte';
  import { Button } from '$lib/components/ui/button';
  import { Card, CardContent, CardHeader, CardTitle } from '$lib/components/ui/card';
  import { Input } from '$lib/components/ui/input';
  import { Label } from '$lib/components/ui/label';
  import { Link } from '@inertiajs/svelte';

  const form = useForm({
    email_address: ''
  });

  const page = usePage();
  let flash = $derived((page.props as any).flash || {});
  let translations = $derived((page.props as any).translations || {});
  let t = $derived(translations.passwords || {});

  function submit(e: Event) {
    e.preventDefault();
    form.post('/passwords');
  }
</script>

<div class="flex items-center justify-center p-4 min-h-[80vh] bg-zinc-50/50">
  <div class="w-full max-w-md space-y-6">
    <Card class="shadow-xl bg-white">
      <CardHeader>
        <CardTitle class="text-2xl text-center font-bold tracking-tight">{t.forgot_title}</CardTitle>
        <p class="text-center text-muted-foreground text-sm px-2">{t.forgot_subtitle}</p>
      </CardHeader>

      <CardContent class="space-y-4">
        {#if flash.alert}
          <div class="bg-destructive/10 border border-destructive/20 text-destructive p-3 rounded-md text-sm">
            {flash.alert}
          </div>
        {/if}

        <form onsubmit={submit} class="space-y-4">
          <div class="space-y-2">
            <Label for="email_address">{t.email_label || 'Email'}</Label>
            <Input
              id="email_address"
              type="email" 
              placeholder="name@example.com"
              bind:value={form.email_address} required
            />
          </div>

          <Button type="submit" class="w-full mt-2" disabled={form.processing}> 
            {form.processing ? t.sending : t.send_instructions}
          </Button>
        </form>

        <div class="text-center text-sm pt-2">
          <Link href="/login" class="text-primary hover:underline font-semibold">
            {t.back_to_login}
          </Link>
        </div>
      </CardContent>
    </Card>
  </div>
</div>